import React,{useEffect,useState} from 'react';
import ListItem from '../components/ListItem';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {allStates} from '../components/Helper';
import { BrowserRouter as Router,Routes, Route, Link,useParams } from 'react-router-dom';
import '../App.css';


const Signup=()=>{

let { state } = useParams();

const [data, setData] = useState(null);
const [foundState, setFoundState] = useState([]);


const dataFetch = async () => {

  if(typeof state === 'undefined'){
    state='';
  }
  fetch('https://api.hudhousingnetwork.com/waitingls?listtype=public_housing&state='+state)
        .then(response => response.json())
        .then((data) =>{ 
            setData(data);
          //console.log(data)
          }
        );

};

const stateFetch = async () => {

  if(typeof state === 'undefined'){
    return
  }
  fetch('https://api.hudhousingnetwork.com/get/'+state)
        .then(response => response.json())
        .then((data) =>{ 
          if(data.length>0)
          setFoundState(data[0].state);
          //console.log("R: "+data[0].state);
          }
        );

};


useEffect(()=>{
 console.log('Loaded!');  
 stateFetch();
 dataFetch();

},[])

const setClick=(val)=>{
  var url='/public-housing-waiting-lists/';
  url=url+val;
  window.location.href=url;
  //console.log("clicked "+val.toLowerCase())
}

/*allStates.map((postData) => {
  if(postData['state_code']=='AL'){
    console.log(postData['state'])
  }
})*/

  return (

<>
  <Header />
  <div className="signup_wrapper">
    <h2 className="top-heading">Signup To Get Access</h2>
    <p>Receive Waiting List Updates, New Property Listings, Real-Time Alerts and More</p>
    <div className="signup-form">
      <input type="text" placeholder="First Name" />
      <input type="text" placeholder="Last Name" />
      <input type="text" placeholder="Email" />
      <input type="text" placeholder="Phone" />
      <input type="text" placeholder="Zipcode" />
      <button className="signup-btn">Become A Member</button>
      <span>Or</span>
      <button className="signup-with-google-btn"><img src="/img/google-icon.png" />Signup with Google</button>
    </div>
  </div>


</>
  );
}

export default Signup;
